// 获取菜单列表
// export const GETMENULIST = 'GETMENULIST'
// 登录
export const LOGIN = 'LOGIN'
// 注销
export const LOGOUT = 'LOGOUT'

export const UserId = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/primarysid'
export const Account = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'
// export const RoleName = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'